'use client';

import { Button } from '@ui/components/button';
import { FullBleedLayout } from '@ui/components/layouts';
import { useMediaQuery } from '@ui/hooks/useMediaQuery';
import { cn } from '@ui/lib/utils';
import { text } from '@modules/garden-planner/text';

import type { GardenPlannerProps } from '@modules/garden-planner/containers/garden_planner_container';
import { PageContentLoading } from '@/src/components/PageContentLoading';
import { AlertMessage } from '@modules/garden-planner/views/alert_message_view';

import { FaIcon } from '@micks-yard/icons/FaIcon';
import { faBars } from '@micks-yard/icons/solid/faBars';
import { faXmark } from '@micks-yard/icons/solid/faXmark';

export function GardenPlanner({
  isLoading,
  alerts,
  onDismissAlert,
  isSidebarOpen,
  onToggleSidebar,
  sidebar,
  main,
}: GardenPlannerProps) {
  const isMd = useMediaQuery('(min-width: 768px)');

  if (isLoading) {
    return <PageContentLoading />;
  }

  return (
    <FullBleedLayout className="flex-row">
      {sidebar}

      <div className={cn('flex min-h-0 flex-1 flex-col overflow-hidden', isMd && 'ml-64')}>
        {main}

        {!isMd ? (
          <Button
            type="button"
            size="icon-lg"
            className="fixed right-6 bottom-6 z-30 size-14 rounded-full shadow-lg"
            aria-label={isSidebarOpen ? text.closeSidebar : text.openSidebar}
            onClick={onToggleSidebar}>
            {isSidebarOpen ? (
              <FaIcon icon={faXmark} className="size-6 text-white" />
            ) : (
              <FaIcon icon={faBars} className="size-6 text-white" />
            )}
          </Button>
        ) : null}
      </div>

      <AlertMessage alerts={alerts} onDismiss={onDismissAlert} />
    </FullBleedLayout>
  );
}
